"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const fontSizes = {
  h1: '80px',
  h2: '32px',
  h3: '28.5px',
  h4: '24px',
  h1mobile: '32px',
  h2mobile: '24px',
  subtitle1: '18.6px',
  subtitle2: '16px',
  subtitle3: '18px',
  subtitle4: '14px',
  body: '16px',
  detail1: '16px',
  detail2: '12.8px',
  detail3: '12.8px'
}; // detail3 = detail2 + bold

var _default = fontSizes;
exports.default = _default;